import { render } from "./ParametersCard.vue?vue&type=template&id=16ea1fc5&scoped=true"
import script from "./ParametersCard.vue?vue&type=script&lang=js"
export * from "./ParametersCard.vue?vue&type=script&lang=js"

import "./ParametersCard.vue?vue&type=style&index=0&id=16ea1fc5&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ea1fc5"]])

export default __exports__